import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy, filters } from "../../service/RefferalService";
import BasicTable from "../../Components/CommonTable/BasicTable/BasicTable";
import StoreModal from "../../Components/Modals/StoreModal/StoreModal";
import { UsersApi } from "../../App/api/users.api";
import ReferralModal from "./Refferal/ReferralModal";
import { toast } from "react-toastify";

const RefferalComponent = ({
  disabledFilters,
  pagination,
  handlePagination,
}) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [refferalCode, setRefferalCodeDAta] = useState(null);

  // const { data: countryData } = useSelector((state) => state.country);

  // const countryFilter = countryData?.map((item) => {
  //   return { name: item?.name, code: item?._id };
  // });

  // const filters = [
  //   {
  //     filterType: "By Country",
  //     inputName: "country",
  //     options: countryFilter,
  //   },
  // ];
  const getAllRefferalCode = async () => {
    try {
      const res = await UsersApi.getAllCustomer(pagination, search);
      setRefferalCodeDAta(res?.data?.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getAllRefferalCode();
  }, []);

  const handleCloseOrderModal = () => {
    setIsOrderDetail(false);
    setSelectedOrder(null);
  };
  const handleRowClick = (row) => {
    setSelectedOrder(row);
    setIsOrderDetail(true);
  };
  const handleCellClick = (cell, field = "") => {
    if (field === "first_name") {
      setSelectedOrder(cell);
      setIsOrderDetail(true);
    }
    if (field === "vendor") {
      setVendorData(cell);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllRefferalCode();
  }, [pagination, search]);

  const DataFilter = filters.filter((f) =>
    disabledFilters ? !disabledFilters.includes(f.inputName) : true
  );
  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={refferalCode?.user}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: refferalCode?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: refferalCode?.totalPages || 1,
          totalCount: refferalCode?.totalCount || 1,
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={DataFilter}
        // WeekRange={false}
        // MonthRange={true}
        // canlenderFilter={canlenderFilter}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
      <ReferralModal
        handleRowClick={handleRowClick}
        isOrderDetail={isOrderDetail}
        handleCloseOrderModal={handleCloseOrderModal}
        referralData={selectedOrder}
      />
      <StoreModal
        itemData={vendorData}
        setToggleUsersDetails={(v) => {
          setVendorData(null);
        }}
        toggleUsersDetails={Boolean(vendorData)}
      />
    </div>
  );
};

export default RefferalComponent;
